"use client";


import { useState, useEffect } from 'react';



const ProductsPage = ({children,ip}) => {

  const [stickyClass, setStickyClass] = useState('top-0');

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);

    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 110 ? setStickyClass('top-[60px]') : setStickyClass('top-0');
    }
  };

    return (
      <>
      {/* <GreenBanner/> */}
      <div className={`w-full min-h-screen h-auto relative ${stickyClass}`}>
      

       {children}
      
        
      </div>
      
      </>
    )
  };
  
  export default ProductsPage;
  